import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataService } from './data.service';
import { User } from '../models/User';
import { Store } from '../../store';
import { EntityTailConfig } from '../models/EntityTailConfig';
import * as _ from 'underscore';
import {SSOUser} from "@frmk2sjs/services";
import {QueryConfig} from "../models/QueryConfig";

@Injectable({
  providedIn: 'root'
})
export class UserProfileResolverService  {
    constructor(private dataService: DataService, private router: Router, private store: Store,private ssoUser: SSOUser) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<User> {

        if (this.store.value.user && this.store.value.user.legalEntities && this.store.value.user.legalEntities.length > 0) {
            return of(this.store.value.user);
        } else {
            this.store.value.user = this.fillUser(this.ssoUser);
        }
        return this.fetchUser();
    }

    fetchUser(): Observable<User> {
        return this.dataService.getUserProfile().pipe(
            map(user => {
                user.legalEntities = _.sortBy(user.legalEntities, (x: any) => x.name);
                this.store.set('user', { ...this.store.value.user, ['legalEntities']: user.legalEntities, ['queryConfig']: user.queryConfig });
                this.populateDefaultEnityTrailConfigForModelling(user);
                user = { ...user, ['isAdmin']: this.store.value.user.isAdmin, ['isSuperAdmin']: Boolean(this.store.value.user.isSuperAdmin) };
                return user;
            })
        );
    }

    fillUser(ssoUser: SSOUser): User {
        return <User>{
            uid: ssoUser.login,
            roles: ssoUser.authorities.toString().toUpperCase(),
            isAdmin: ssoUser.authorities.toString().toUpperCase().includes('ADMIN'),
            isSuperAdmin: ssoUser.authorities.toString().toUpperCase().includes('SUPERADMIN')
        };
    }

    public populateDefaultEnityTrailConfigForModelling(user: User) {
        let entityTailConfigs: EntityTailConfig[];
        entityTailConfigs = [];
        _.each(user.legalEntities, x => {
            entityTailConfigs.push({
                legalEntity: x,
                yearRangeTails: [
                    { from: 0, to: 120, tail: 0.02 }
                ]
            });
        });
        this.store.value.modellingConfig.entityTailConfigs = entityTailConfigs;
        this.store.set('modellingConfig', this.store.value.modellingConfig);
    }
}
